import './JiraStatusMapping.scss';
import { ArrowRightOutlined } from '@ant-design/icons';
import { AsyncStateNotification } from '@ui/notifications';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { InitiativeStatusSelector } from '../../initiatives/StatusSelector';
import { SonarText } from '@ui/text';
import { Col, Row } from 'antd';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { jiraStatusSelectors, jiraSummarySelectors } from './@arch/selectors';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser, useSonarSelector } from '@hooks';
export const JiraStatusMapping = ({ status }) => {
    const { customerId } = useCurrentUser();
    const postJiraStatus = useAction(integrationsActions.requestPostJiraStatuses);
    const isReceived = useSonarSelector(jiraSummarySelectors.isReceived);
    const handleStatusChange = useCallback((jiraStatusId) => (initiativeStatusId) => {
        postJiraStatus({
            customerId,
            initiativeStatusId,
            jiraStatusId
        });
    }, [customerId, postJiraStatus]);
    const defaultValue = status.initiativeStatusId ? String(status.initiativeStatusId) : 'Select Arovy Status';
    return (React.createElement("div", { className: 'jira-status-mapping' },
        React.createElement(Row, { key: status.jiraStatusId },
            React.createElement(Col, { span: 8 },
                React.createElement(SonarText, null, status.jiraStatusLabel)),
            React.createElement(Col, { span: 5 },
                React.createElement(ArrowRightOutlined, null)),
            React.createElement(Col, { span: 11 },
                React.createElement(InitiativeStatusSelector, { defaultValue: defaultValue, loading: !isReceived, noConfetti: true, onChange: handleStatusChange(status.jiraStatusId) }))),
        React.createElement(AsyncStateNotification, { errored: COPY_GENERIC.CONTACT_SUPPORT, failed: COPY_GENERIC.CONTACT_SUPPORT, resetRawAction: integrationsActions.resetPostJiraStatuses, stateSelector: jiraStatusSelectors.state })));
};
